// extracted by mini-css-extract-plugin
export var divider = "_pz-0";
export var systemMessage = "_pz-1";